//@flow
import _ from 'lodash';
import * as React from 'react';
import { connect } from 'react-redux';
import IconDelete from '../../images/icon_x_red.svg';
import { posologiaService } from '../../_services/posologia.service';
import FormInput from '../inputs/FormInput';
import FormSelectInput from '../inputs/FormSelectInput';
import InputViewEdit from '../inputs/InputViewEdit';

type Props = {
  medicamento: any,
  removeItem: any,
  viewMode: Boolean,
};

class MedicamentoFormula extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
  }

  render() {
    const { entity, propName, index, viewMode, size } = this.props;

    return (
      <div className="form-row d-flex flex-row align-items-start med-prescrito">
        <label className="w-100 mb-2">
          <b>Fórmula</b>
        </label>
        <div className="col-12 col-lg d-flex align-items-center justify-content-center number">
          {' '}
          {viewMode ? index + 1 : 'F'}
        </div>
        <div className="col-12 col-lg-10 flex-column">
          <div className="mb-1">
            <InputViewEdit
              component={FormInput}
              label=""
              id={`formula${index}`}
              onChange={this.props.onChange}
              viewMode={viewMode}
              viewClassName={'font-weight-bold pl-1'}
              placeholder="Insira aqui o nome da formula"
              required={true}
              value={_.get(entity, `${propName}.formula`)}
              name={`${propName}.formula`}
            />
          </div>
          <div className="mb-1">
            <InputViewEdit
              component={FormSelectInput}
              id={this.props.id}
              name={`${propName}.posologia`}
              service={posologiaService.find}
              onChange={this.props.onChange}
              value={this.props.value}
              labelKey="descricao"
              isMulti={false}
              returnFullObject={true}
              creatable={true}
              cache={true}
              //   components={{ Option: OptionUsuario }}
              placeholder="Posologia"
              parent={{
                medico: this.props.user,
                medicamento: _.get(entity, `${propName}.medicamento`),
              }}
              value={_.get(entity, `${propName}.posologia`)}
              defaultValue={_.get(entity, `${propName}.posologia.descricao`)}
              viewMode={viewMode}
              viewClassName={'font-weight-bold pl-1'}
            />
          </div>
        </div>
        {!viewMode && (
          <div className="col-12 col-lg d-flex justify-content-center btn-action p-0">
            <div
              className={`icon-delete d-flex align-items-center justify-content-center`}
              onClick={() => {
                this.props.removeItem();
              }}
            >
              <img src={IconDelete} alt="Deletar medicamento" />
            </div>
          </div>
        )}
        {/* <hr></hr> */}
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { user } = state.authentication;
  return {
    user,
  };
}

const mapDispatch = ({
  alert: { success, error, clear },
  load: { loading },
}) => ({
  success: (msg) => success(msg),
  loading: (load: boolean) => loading({ load }),
  error: (msg) => error(msg),
  clear: () => clear(),
});

export default connect(mapStateToProps, mapDispatch, null, {
  forwardRef: true,
})(MedicamentoFormula);
